module.exports = __webpack_public_path__ + "img/credit-score-managment-2.953fea3d.png";